module.exports = __webpack_public_path__ + "img/artboard6.4dc35366.png";